import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot} from '@angular/router';
import {of} from 'rxjs';

import {AuthService} from '../services/auth.service';

@Injectable()
export class UserResolve {
  constructor(private auth: AuthService) {}

  resolve(route: ActivatedRouteSnapshot) {
    const user = route.parent?.data.user;
    if (user) {
      return of(user);
    }
    const refModelId = route.url[0]?.path?.includes('customView')
      ? route.parent.params['refModelId']
      : route.params['refModelId'] ?? route.parent?.params['refModelId'];

    return this.auth.fetchUser(refModelId);
  }
}
